import React, { useContext, useEffect, useState } from 'react';
import './../theme/layout_orange.css';
import zh_TW from 'antd/es/locale/zh_TW';
import { ConfigProvider } from 'antd';
import RouteEducation from '../components/DemoWms/RouteEducation';
import './i18n'; // 引入 i18n 設置

const Demosite = () => {
    const onChangeLanguage = (value) => {
        const localeValue = value;
        setLocal(localeValue);
    }
    const [locale, setLocal] = useState(zh_TW);
    
    return (<>
        <ConfigProvider 
            locale={locale}
            theme={{
                token: {
                    //橘色
                    colorPrimary: '#fa8c16',
                    fontSize: 16
                },
            }}>
            <RouteEducation
                onChangeLanguage={onChangeLanguage}
                admin={true}
            />
        </ConfigProvider>
    </>)
}
export default Demosite;
